/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

import EmblaCarousel, {
  EmblaCarouselType,
  EmblaOptionsType,
} from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

export function initImageSlider(): void {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  )
  const imageSliders = Array.from(
    document.querySelectorAll('.image-slider'),
  ) as HTMLElement[]

  for (const imageSlider of imageSliders) {
    if (imageSlider.dataset.hydrated) continue
    imageSlider.dataset.hydrated = 'true'
    const prev = imageSlider.querySelector(
      '.image-slider__controls-nav-arrow--prev',
    ) as HTMLElement | null
    const next = imageSlider.querySelector(
      '.image-slider__controls-nav-arrow--next',
    ) as HTMLElement | null
    const track = imageSlider.querySelector(
      '.image-slider__list-track',
    ) as HTMLElement | null
    const list = imageSlider.querySelector(
      '.image-slider__list',
    ) as HTMLElement | null
    const count = imageSlider.querySelector(
      '.image-slider__controls-count-current',
    ) as HTMLElement | null
    const countTotal = imageSlider.querySelector(
      '.image-slider__controls-count-total',
    ) as HTMLElement | null

    if (!prev || !next || !track || !count || !countTotal || !list) {
      continue
    }

    const options: EmblaOptionsType = {
      slidesToScroll: 1,
      loop: false,
      align: 'start',
      containScroll: false,
    }

    const animationOptions = () => {
      return prefersReducedMotion.matches ? { duration: 0 } : { duration: 25 }
    }

    const emblaApi = EmblaCarousel(track, {
      ...options,
      ...animationOptions(),
    }, [WheelGesturesPlugin()])

    prefersReducedMotion.addEventListener('change', () => {
      emblaApi.reInit({
        ...options,
        ...animationOptions(),
      })
    })

    prev.addEventListener('click', () => emblaApi.scrollPrev(), false)
    next.addEventListener('click', () => emblaApi.scrollNext(), false)

    const handleSelect = () => {
      const setButtonState = (button: HTMLElement, enabled: boolean) => {
        button.toggleAttribute('disabled', !enabled)
      }
      setButtonState(prev, emblaApi.canScrollPrev())
      setButtonState(next, emblaApi.canScrollNext())

      count.innerText = (emblaApi.selectedScrollSnap() + 1).toString().padStart(
        2,
        '0',
      )
    }

    handleSelect()

    emblaApi.on('select', handleSelect)

    countTotal.innerText = list.childElementCount.toString().padStart(2, '0')
  }
}
